import { css } from '@/styled-system/css';

export const assistChipIconStyles = css.raw({
  color: 'icon.neutral',
  marginInlineEnd: 'tighter',
});
